import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '@services/security';

@Injectable({
    providedIn: 'root',
})
export class ProfileService {
    profile;
    showNav = new BehaviorSubject<boolean>(false);
    currentNavigation = this.showNav.asObservable();
    previousNavigation = new BehaviorSubject<string>(null);
    labels = ['general'];

    constructor(private http: HttpClient, private authService: AuthService) {}

    getProfile(id) {
        return this.http
            .get<any>(`${environment.apiUrl}/profile/${id}`)
            .pipe(map(({ profile }) => profile));
    }

    selectProfile(id) {
        return this.http
            .put<any>(`${environment.apiUrl}/select-profile/${id}`, {})
            .pipe(map(({ profile }) => profile));
    }

    initProfile(type?) {
        this.profile = {
            iconName: 'heart',
            type,
            permissions: {},
        };

        const GENERAL_PERMISSIONS = {
            canManageProfilesAndUsers: false,
            canInstallPatients: false,
            canOnlyReadBills: false,
            canBill: false,
        };

        const LABEL_PERMISSIONS = {
            canActivateView: false,
            canBeReferent: false,
            canIncludePatient: false,
            canReincludePatient: false,
            canStopPatient: false,
            canReportEvent: false,
            canGeneratePrescription: false,
            canGeneratePrescriptionBioTherapeutic: false,
            canViewMedicalAlerts: false,
            canManageMedicalAlerts: false,
            canSendSMS: false,
            canConsultDocumentsAndPrescriptions: false,
            canImportDocumentOnPatientRecord: false,
            canEditAdministrativeInfos: false,
            canEditMedicalInfos: false,
            canViewMedicalEventsAndComment: false,
            canViewTechnicalEventsAndComment: false,
            canViewTherapyCoaching: false,
            canAddTherapyCoachingSession: false,
        };
        const SERVICES_LIST = ['general', 'cardio', 'nephro', 'onco', 'geriatry', 'pediatry', 'study']

        SERVICES_LIST.forEach(label => {
            this.profile.permissions[label] =
                label === 'general'
                    ? { ...GENERAL_PERMISSIONS }
                    : { ...LABEL_PERMISSIONS };
        });
        return this.profile;
    }

    updateProfile(body) {
        return this.http.put<any>(`${environment.apiUrl}/profile`, body);
    }

    deleteProfile(profileId) {
        return this.http.put<any>(
            `${environment.apiUrl}/profile/${profileId}`,
            {},
        );
    }

    getProfiles(companyId?) {
        let params;
        const currentCompany = this.authService.getCurrentCompany?.();
        if (this.authService.isAdmin ? companyId : currentCompany) {
            params = {
                companyId: this.authService.isAdmin
                    ? companyId
                    : currentCompany,
            };
        }
        return this.http.get<any>(`${environment.apiUrl}/profiles`, { params });
    }

    detachExternProfile(userId) {
        return this.http.put<any>(
            `${environment.apiUrl}/profile/extern/detach/${userId}`,
            {},
        );
    }

    updateShowNav(newData: boolean) {
        this.showNav.next(newData);
    }

    setPreviousRoute(url) {
        this.previousNavigation.next(url);
    }

    getPreviousRoute(profile?) {
        return this.previousNavigation?.value || this.defaultRoute(profile);
    }

    defaultRoute(profile) {
        if (profile?.companyId) return `/company/${profile.companyId}/profiles`;
        return '/dashboard';
    }
}
